import { render, staticRenderFns } from "./etcExchange.vue?vue&type=template&id=56d1c121&scoped=true&"
import script from "./etcExchange.vue?vue&type=script&lang=js&"
export * from "./etcExchange.vue?vue&type=script&lang=js&"
import style0 from "./etcExchange.vue?vue&type=style&index=0&id=56d1c121&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d1c121",
  null
  
)

export default component.exports